import {TimerCountUp} from '../../../../controls/agyle/timer';
import React from 'react';
import {ToggleButtonGroup, Tooltip} from '@mui/material';
import {useSepsisFromStyles} from '../sepsisPathwayForm';
import {useTranslation} from 'react-i18next';
import clsx from 'clsx';
import ToggleButton from '@mui/material/ToggleButton';
import Formatter from '../../../../util/formatter';
import {SepsisPathwayStatus} from '../sepsisUtil';

const SepsisPathwaySelect = ({
                                 sepsisField,
                                 sepsisPathwayObj,
                                 canEditSepsis,
                                 setSepsisPathwayField,
                                 setReason,
                                 setReasonRelatedField,
                                 openReason,
                                 isPaeds = false,
                             }) => {
    const classes = useSepsisFromStyles();
    const {t} = useTranslation();

    const showBorder = !isPaeds && sepsisPathwayObj[sepsisField.field] !== null || (sepsisPathwayObj[sepsisField.field] == null && sepsisPathwayObj[sepsisField.field + 'TimeoutDate'] && sepsisPathwayObj.statusObj === SepsisPathwayStatus.INCOMPLETE);

    const handleChange = (_e, newAlignment) => {
        if (canEditSepsis) {
            const currentVal = sepsisPathwayObj[sepsisField.field];

            if (isPaeds) {
                newAlignment ?
                setSepsisPathwayField(sepsisField.field, true, undefined, sepsisField.field + 'NAReason', false) :
                setSepsisPathwayField(sepsisField.field + 'NAReason', true, undefined, sepsisField.field, false)
            } else if (newAlignment && currentVal !== newAlignment) {
                setSepsisPathwayField(sepsisField.field, newAlignment, undefined, null, null);
            } else {
                setReason(null);
                setReasonRelatedField(sepsisField.field);
                openReason();
            }
        }
    };

    const renderBox = () => {
        if (sepsisPathwayObj[sepsisField.field] == null && sepsisPathwayObj[sepsisField.field + 'TimeoutDate'] && sepsisPathwayObj.statusObj === SepsisPathwayStatus.INCOMPLETE) {
            return (
                <div className={clsx(classes.divRow, classes.toggleText)}>
                    <div
                        style={{
                            display: 'inline-block',
                            minWidth: 'max-content',
                        }}
                    >
                        {t('Time remaining')}:&nbsp;
                    </div>

                    <div style={{display: 'inline-block'}}>
                        <TimerCountUp
                            time={sepsisPathwayObj[sepsisField.field + 'TimeoutDate']}
                            limit={15}
                            upperLimit={1}
                            limitMessage={t('Times up!')}
                            countDown
                        />
                    </div>
                </div>
            );
        }

        return (
            <div>
                <Tooltip
                    title={sepsisPathwayObj[sepsisField.field] === false ? t('Reason') + ': ' + sepsisPathwayObj[sepsisField.field + 'NAReason'] : ''}
                    arrow
                >
                    <div className={classes.toggleText}>
                        <div>{sepsisPathwayObj[sepsisField.field] === false ? 'N/A by' : 'Checked by'}</div>
                        <div className={classes.checkedName}>{sepsisPathwayObj[sepsisField.field + 'CheckedBy']}</div>
                        <div>{Formatter.dateFormatted(sepsisPathwayObj[sepsisField.field + 'CheckedByDate'], 'DD/MM/YYYY HH:mm:ss')}</div>
                    </div>
                </Tooltip>
            </div>
        );
    };

    return (
        <div className={clsx(classes.sepsisToggle, showBorder && 'border')}>
            <ToggleButtonGroup
                onChange={handleChange}
                value={sepsisPathwayObj[sepsisField.field]}
                exclusive
                disabled={!canEditSepsis || sepsisPathwayObj.statusObj !== SepsisPathwayStatus.INCOMPLETE}
                color="primary"
                size="small"
                fullWidth
                className={classes.toggleRoot}
            >
                <ToggleButton
                    value={true}
                    className={classes.toggleRoot}
                    classes={{selected: classes.toggleSelect}}
                >
                    {t(isPaeds ? 'Yes' : 'Check')}
                </ToggleButton>

                <ToggleButton
                    value={false}
                    className={classes.toggleRoot}

                    classes={{selected: classes.toggleSelect}}
                >
                    {t(isPaeds ? 'No' : 'N/A')}
                </ToggleButton>
            </ToggleButtonGroup>

            {showBorder && renderBox()}
        </div>
    );
};

export default SepsisPathwaySelect;